
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#224CA4","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.938 3.438A4.595 4.595 0 007.33 8.046a4.595 4.595 0 004.608 4.609 4.595 4.595 0 004.608-4.61 4.595 4.595 0 00-4.608-4.607zm0 1.5a3.095 3.095 0 013.108 3.108 3.095 3.095 0 01-3.108 3.109 3.095 3.095 0 01-3.108-3.11 3.095 3.095 0 013.108-3.107zM6.29 4.378a.75.75 0 010 1.5 2.152 2.152 0 100 4.303.75.75 0 010 1.5 3.652 3.652 0 110-7.303zm14.957 3.652a3.652 3.652 0 00-3.652-3.652.75.75 0 000 1.5 2.152 2.152 0 110 4.303.75.75 0 000 1.5 3.652 3.652 0 003.652-3.651zm-.751 5.524a10.08 10.08 0 00-1.515-.219.75.75 0 00-.104 1.497c.447.03.885.094 1.31.19.662.13 1.093.345 1.2.57a.63.63 0 010 .539c-.106.222-.534.436-1.186.57a.75.75 0 10.302 1.47c1.078-.222 1.868-.617 2.238-1.396.275-.58.275-1.251 0-1.829-.373-.782-1.176-1.183-2.245-1.392zm-14.792.478a.75.75 0 00-.8-.697c-.522.037-1.035.11-1.535.223l-.207.044c-.948.216-1.67.614-2.018 1.344a2.124 2.124 0 000 1.83c.37.777 1.16 1.173 2.238 1.395a.75.75 0 10.302-1.47c-.652-.134-1.08-.348-1.185-.57a.626.626 0 010-.54c.106-.224.537-.44 1.178-.565l.334-.068c.332-.062.662-.103.996-.126a.75.75 0 00.697-.8zm-.537 3.152c0-2.386 2.468-3.225 6.77-3.225l.306.001c4.123.039 6.466.88 6.466 3.206 0 2.272-2.24 3.142-6.17 3.22l-.601.005c-4.313 0-6.77-.824-6.77-3.207zm12.042-.018c0-1.11-1.781-1.708-5.271-1.708-3.487 0-5.27.607-5.27 1.726 0 1.11 1.78 1.707 5.27 1.707 3.486 0 5.27-.607 5.27-1.725z","fill":"inherit"}})])
          )
        }
      }
    